// alternateMemoryCharged Reducer
const alternateMemoryChargedDefaultState = {
    dateNaissance: null,
    prenom: '',
    nom: '',
    address: '',
    zipCode: '',
    city: '',
    codeCountry : '',
    idBeneficiaire:'',
    email:'',
    telephone:'',
    alternateCharged : '1'
};

export default (state = alternateMemoryChargedDefaultState, action) => {
    switch (action.type) {
        case 'SET_ALTERNATE_MEMEORY_CHARGED':
            return {
                ...state,
                dateNaissance: action.data.date,
                prenom: action.data.firstName,
                nom: action.data.name,
                address: action.data.address,
                email:action.data.email,
                telephone:action.data.telephone,
                zipCode: action.data.zipCode,
                city: action.data.city,
                codeCountry : action.data.codeCountry,
                idBeneficiaire:action.data.idBeneficiaire,
                alternateCharged : action.data.alternateCharged,
                role:'alternateMemoryCharged'
            };
            case 'GET_ALTERNATE_MEMEORY_CHARGED':
            return {
                ...state,
                dateNaissance: action.data.dateNaissance,
                prenom: action.data.prenom,
                nom: action.data.nom,
                address: action.data.address,
                zipCode: action.data.codePostal,
                city: action.data.ville,
                codeCountry: action.data.codeCountry,
                email: action.data.email,
                telephone: action.data.telephone,
                idBeneficiaire: action.data.idBeneficiaire,
                alternateCharged : action.data.alternateCharged,
                role: 'alternateMemoryCharged'
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/alternateMemoryCharged.js